<template>
  <ai-carousel-with-description
    v-if="images && images.length"
    id="HotelKidsAndFamily"
    v-model="currentStep"
    mobile-button
    access-id="HotelKidsAndFamilyCarousel"
    background="neutral"
    :items="items"
    :title="$t('hotel.kidsAndFamily.title')"
    :description="description"
    :gutter="gutter"
    :aria-label="$t('accessibility.description.hotelKidsandFamilyCarousel')"
    :slide-width="slideWidth"
    gallery-on-carousel-click />
</template>

<script setup lang="ts">
interface HotelWelcomeProps {
  images: AiImageProps[];
  description: string;
}

const props = defineProps<HotelWelcomeProps>();
const items = props.images.map(image => ({ ...image, loading: 'lazy' }));

const isSmallDevice = useMatchMediaQuery('tablet');
const isDesktopDevice = useMatchMediaQuery('large-desktop');

const gutter = computed(() => {
  if (isSmallDevice.value) return 16;

  return isDesktopDevice.value ? 64 : 32;
});
const slideWidth = computed(() => (isSmallDevice.value ? 0.9 : 1));

const currentStep = ref<number>(1);
</script>
